import axios from "axios";
import { API_HOST } from "../main";

export default {
  create: eventData => {
    return new Promise((resolve, reject) => {
      axios
        .put(`${API_HOST}/api/v1/events/`, eventData)
        .then(response => resolve(response.data))
        .catch(e => reject(e));
    });
  },

  getByCity: cityId => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${API_HOST}/api/v1/events/`, {
          params: {
            cityId: cityId
          }
        })
        .then(response => resolve(response.data))
        .catch(e => reject(e));
    });
  },

  getOne: eventId => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${API_HOST}/api/v1/events/${eventId}/`)
        .then(response => resolve(response.data))
        .catch(e => reject(e));
    });
  },

  update: (eventId, eventData) => {
    return new Promise((resolve, reject) =>
      axios
        .post(`${API_HOST}/api/v1/events/${eventId}/`, eventData)
        .then(() => resolve())
        .catch(e => reject(e))
    );
  }
};
